import React from 'react';
import { Hammer, PaintBucket, Layers, Home } from 'lucide-react';

export const Gewerke = () => {
  const gewerke = [
    {
      id: 1,
      title: 'Dacharbeiten',
      description: 'Professionelle Dachdeckerarbeiten, Dachsanierung und Dachreparaturen',
      icon: Home,
      features: ['Dachsanierung', 'Dachneueindeckung', 'Dachreparatur', 'Dachfenster']
    },
    {
      id: 2,
      title: 'Malerarbeiten',
      description: 'Hochwertige Maler- und Lackierarbeiten für Innen und Außen',
      icon: PaintBucket,
      features: ['Innenanstrich', 'Fassadenanstrich', 'Lackierarbeiten', 'Tapezierarbeiten']
    },
    {
      id: 3,
      title: 'Trockenbau',
      description: 'Professioneller Trockenbau für Wände, Decken und Dachausbau',
      icon: Layers,
      features: ['Wandsysteme', 'Deckensysteme', 'Dachausbau', 'Schallschutz']
    },
    {
      id: 4,
      title: 'Rohbauarbeiten',
      description: 'Solide Rohbauarbeiten mit Maurer- und Betonarbeiten',
      icon: Hammer,
      features: ['Maurerarbeiten', 'Betonarbeiten', 'Fundamente', 'Mauerwerksbau']
    }
  ];

  return (
    <section id="gewerke" className="py-12 relative overflow-hidden bg-gradient-to-b from-white to-gray-50">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-black via-[#00CCDD] to-black"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8">
          <div className="inline-flex items-center space-x-2 bg-black text-white px-6 py-2 rounded-full mb-4">
            <Hammer className="w-4 h-4" />
            <span className="font-semibold text-sm uppercase tracking-wide">Unsere Kerngewerke</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-3">
            Auch für <span className="text-transparent bg-clip-text bg-gradient-to-r from-black to-[#00CCDD]">Einzelaufträge</span> Ihr Partner
          </h2>
          <p className="text-lg text-gray-600">
            Neben schlüsselfertigem Bau sind wir Experten in diesen Gewerken - auch für Einzelprojekte
          </p>
        </div>

        {/* Gewerke Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {gewerke.map((gewerk, index) => {
            const IconComponent = gewerk.icon;
            
            return (
              <div 
                key={gewerk.id} 
                className="group relative bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-[#00CCDD] overflow-hidden"
              >
                {/* Hover background effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-black to-[#00CCDD] opacity-0 group-hover:opacity-5 transition-opacity duration-500"></div>
                
                {/* Number badge */}
                <div className="absolute top-4 right-4 text-6xl font-bold text-gray-100 group-hover:text-[#00CCDD]/20 transition-colors">
                  0{index + 1}
                </div>
                
                <div className="relative">
                  {/* Icon */}
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-black to-[#00CCDD] flex items-center justify-center mb-5 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl font-bold text-black mb-3 group-hover:text-[#00CCDD] transition-colors">
                    {gewerk.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {gewerk.description}
                  </p>
                  
                  {/* Features */}
                  <ul className="space-y-2">
                    {gewerk.features.map((feature, idx) => (
                      <li key={`${gewerk.id}-feature-${idx}`} className="flex items-center text-sm text-gray-500">
                        <span className="w-1.5 h-1.5 bg-[#00CCDD] rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                
                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-black to-[#00CCDD] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-8">
          <a 
            href="#contact" 
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-black to-[#00CCDD] text-white px-6 py-3 rounded-full font-semibold hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <span>Jetzt Angebot anfragen</span>
          </a>
        </div>
      </div>
    </section>
  );
};
